import React, { useState } from 'react';
import { 
    Box, 
    Typography, 
    TextField, 
    Button, 
    Paper, 
    Container,
    Alert,
    CircularProgress
} from '@mui/material';
import { authService } from '../../services/api';
import { LockOutlined } from '@mui/icons-material';

const ChangePassword = () => {
    const [formData, setFormData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        
        // Validate passwords
        if (formData.newPassword !== formData.confirmPassword) {
            setError('New password and confirmation do not match');
            return;
        }
        
        if (formData.newPassword.length < 6) {
            setError('New password must be at least 6 characters long');
            return;
        }
        
        setLoading(true);
        try {
            const response = await authService.changePassword(
                formData.oldPassword,
                formData.newPassword,
                formData.confirmPassword
            );
            
            if (response.data.success) {
                setSuccess(response.data.message);
                // Clear form
                setFormData({
                    oldPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                });
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Failed to change password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm">
            
                <Box sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    mb: 3
                }}>
                    <LockOutlined sx={{ fontSize: 40, color: 'text.primary', mb: 1 }} />
                    <Typography component="h1" variant="h5" fontWeight="bold">
                        Change Password
                    </Typography>
                </Box>
                
                {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
                {success && <Alert severity="success" sx={{ width: '100%', mb: 2, color: '#ffffff' }}>{success}</Alert>}

                <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="oldPassword"
                        label="Current Password"
                        type="password"
                        id="oldPassword"
                        value={formData.oldPassword}
                        onChange={handleChange}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="newPassword"
                        label="New Password"
                        type="password"
                        id="newPassword"
                        value={formData.newPassword}
                        onChange={handleChange}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="confirmPassword"
                        label="Confirm New Password"
                        type="password"
                        id="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2, py: 1.5 }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} /> : 'Change Password'}
                    </Button>
                </Box>
        </Container>
    );
};

export default ChangePassword;
